<template>
  <div class="navTab-warpper">
    <el-tag
      class="route-tag"
      :class="isActive==(tag.meta.activeNav||tag.path)&&'isActive'"
      :key="index"
      v-for="(tag,index) in list"
      closable
      :disable-transitions="false"
      @click="handleSelectRoute(tag)"
      @close="handleClose(tag)">
      {{tag.meta.title}}
    </el-tag>
  </div>
</template>

<script>
  import navTabJs from "./navTab.js"

  export default navTabJs
</script>

<style lang="scss" scoped>
  @import "navTab.scss";
</style>



// WEBPACK FOOTER //
// src/layout/navTab/navTab.vue